import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/shared/service/common/common.service';

@Component({
  selector: 'app-review-result',
  templateUrl: './review-result.component.html',
  styleUrls: ['./review-result.component.scss']
})
export class ReviewResultComponent implements OnInit {
  @Input() step: number;
  @Input() getProjectCategory: number;
  @Input() electromechanical: boolean;
  @Input() civilEngineering: boolean;
  @Output() reviewResultChangEmitter = new EventEmitter<object>();
  @Output() budgetCodeAndCreditDepartment = new EventEmitter<Object>();

  radioValue = "";

  civilChecked: boolean;
  elecChecked: boolean;

  civilRemark = "";
  electroRemark = "";

  agreeRemark = "";
  rejectRemark = "";
  formBudgetCharge = {};

  // 厂别选择
  plantArr = [];
  plantOption = [];

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.plantArr = JSON.parse(JSON.stringify(this.commonService.configJson['common']['wzsPlant']));
    this.plantArr.forEach(ele => {
      this.plantOption.push({ label: ele, value: ele });
    })
  }

  // 同意or驳回?
  nzRadioChang(checked: string) {
    this.radioValue = checked;
    if (this.radioValue === 'agree') {
      this.reviewResultChangEmitter.emit({ 'status': 1 });
    }
    else {
      if (this.step == 6) {//厂务概算制定
        this.reviewResultChangEmitter.emit({ 'status': 5 });
      }
      else {
        this.reviewResultChangEmitter.emit({ 'status': 2 });
      }
    }
  }

  // 驳回土建or机电?
  nzCheckChanged(event: string, name: string) {
    if (name === 'civil') {
      this.civilChecked = Boolean(event);
    }
    if (name === 'elec') {
      this.elecChecked = Boolean(event);
    }

  }

  // 同意/驳回的理由
  nzInputChang(remark: string, name?: string) {
    if (name === undefined) {
      this.rejectRemark = remark;
      this.reviewResultChangEmitter.emit({ 'status': 2, 'remark': this.rejectRemark });
    }
    else if (name === 'agree') {//厂务概算制定同意
      this.agreeRemark = remark;
      this.reviewResultChangEmitter.emit({ 'status': 1, 'remark': this.agreeRemark });
    }
    else {//厂务概算制定
      if (name === 'civil') {
        this.civilRemark = remark;
        this.reviewResultChangEmitter.emit({ 'status': 2, 'civilRemark': this.civilRemark });
      }
      if (name === 'elec') {
        this.electroRemark = remark;
        this.reviewResultChangEmitter.emit({ 'status': 3, 'electroRemark': this.electroRemark });
      }
      if (this.civilChecked === true && this.elecChecked === true) {
        this.reviewResultChangEmitter.emit({ 'status': 4, 'civilRemark': this.civilRemark, 'electroRemark': this.electroRemark });
      }
    }
  }

  ngBudgetCodeAndCreditDepartmentChange(e: string, key: string) {
    this.formBudgetCharge[key] = e;
    this.budgetCodeAndCreditDepartment.emit(this.formBudgetCharge);
  }
}
